/**
 * Team names matching the original game
 * Teams: Orange (0), Cyan (1), Red (2), Purple (3), Yellow (4), Green (5), Blue (6), Gray (7)
 */
export const TEAM_NAMES = [
  "Orange",
  "Cyan",
  "Red",
  "Purple",
  "Yellow",
  "Green",
  "Blue",
  "Gray",
];

/**
 * Team colors matching the palette from game.ts
 * Colors: #FF7D00, #00E1FF, #FF0000, #FF00FF, #FFFF00, #00FF00, #2828FF, #AAAAAA
 */
export const TEAM_COLORS = [
  "#FF7D00", // Orange
  "#00E1FF", // Cyan
  "#FF0000", // Red
  "#FF00FF", // Purple
  "#FFFF00", // Yellow
  "#00FF00", // Green
  "#2828FF", // Blue
  "#AAAAAA", // Gray
];

/**
 * Message variant colors for positive/negative outcomes
 */
export const MESSAGE_VARIANT_COLORS = {
  positive: "#00ff88", // Green for positive outcomes (victory, success)
  negative: "#ff4444", // Red for negative outcomes (defeat, failure)
} as const;

